import { api } from '@/scripts/api';

export const FileService = {

    post(payload, queries= {}) {

        return new Promise((resolve, reject) => {
            const queryParams =[];
            for (const key in queries) {
                if (Object.prototype.hasOwnProperty.call(queries, key)) {
                    queryParams.push(`${key}=${queries[key]}`) ;
                }
            }
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            const service  = `/api/Files${queryString}`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject)

        });
    },

    getVendorOverviewMetrics({config, accountId}) {
        return new Promise((resolve, reject) => {
            const service = `/ms/files/v1/file-vendors/account/${ accountId }/report/overview`;
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint)
                .then(resolve)
                .catch(reject)
        })
    },

    getVendorBoardData({ config, accountId }, signal) {
        return new Promise((resolve, reject) => {
            const service = `/ms/files/v1/file-vendors/account/${ accountId }/report/board`;
            const endpoint = api.applyNodeDataParams(service, config);

            api.get(endpoint, signal)
                .then(resolve)
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        reject(error);
                    }
                })
        })
    },

    exportPdfReport(accountId, startDate, endDate) {
        return new Promise((resolve, reject) => {
            const endpoint = `/ms/files/v1/file-vendors/account/${accountId}/report/export/pdf?startDate=${startDate}&endDate=${endDate}`;

            api.post(endpoint)
                .then(resolve)
                .catch(reject)
        })
    },

    exportExcelReport(accountId, startDate, endDate) {
        return new Promise((resolve, reject) => {
            const endpoint = `/ms/files/v1/file-vendors/account/${accountId}/report/export/excel?startDate=${startDate}&endDate=${endDate}`;

            api.post(endpoint)
                .then(resolve)
                .catch(reject)
        })
    },
}
